import NewBatteriesListModal from './new-batteries-list-modal.connect'

export default NewBatteriesListModal
